import React from 'react'
import Onboarding from 'src/app/Onboarding/Onboarding'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { onboardingRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const OnboardingAppRoute: AppRoute = {
  id: AppLocation.Onboarding,
  routeProps: onboardingRouteProps,
  component: <Onboarding />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default OnboardingAppRoute
